<template>
    <div class="xc-modal xc-modal-page">
        <div class="xc-modal-wrap">
            <div class="xc-modal-content">
                <div class="xc-modal-header">
                    <div class="xc-modal-title">文件增播</div>
                    <div class="xc-modal-close" @click="layerClose"></div>
                </div>
                <div class="xc-modal-body">
                    <form
                        class="xc-form"
                        name="filesplay"
                        @submit.prevent="veeFormSubmit"
                        data-vv-scope="form-list"
                    >
                        <div class="xc-form-inline">
                            <!-- <xc-form-item
                label="终端类型"
                required
                :error="errors.first('deviceType','value')"
              >
                <input
                  v-validate="'required'"
                  data-vv-as="终端类型"
                  name="deviceType"
                  type="text"
                  maxlength="255"
                  class="xc-input xc-input-readonly"
                  readonly
                  v-model="deviceType"
                  value="input内容"
                >
              </xc-form-item> -->

                            <xc-form-item
                                label="分辨率"
                                required
                                :error="
                                    errors.first('deviceResolution', 'value')
                                "
                            >
                                <input
                                    v-validate="'required'"
                                    data-vv-as="分辨率"
                                    name="deviceResolution"
                                    type="text"
                                    maxlength="255"
                                    class="xc-input xc-input-readonly"
                                    readonly
                                    v-model="deviceResolution"
                                    value="input内容"
                                />
                            </xc-form-item>

                            <xc-form-item
                                label="节目名称"
                                required
                                :error="errors.first('programName', 'value')"
                            >
                                <input
                                    v-validate="'required'"
                                    data-vv-as="节目名称"
                                    name="programName"
                                    v-model="programName"
                                    type="text"
                                    maxlength="255"
                                    class="xc-input"
                                    placeholder="请输入"
                                />
                            </xc-form-item>
                            <xc-form-item
                                label="开始时间"
                                required
                                :error="errors.first('putinStartTime', 'value')"
                                class="xc-form-item-fixed"
                            >
                                <flat-pickr
                                    v-model="putinStartTime"
                                    class="xc-input"
                                    :config="config"
                                    placeholder="请选择时间"
                                    name="putinStartTime"
                                    v-validate="'required'"
                                    data-vv-as="增播开始时间"
                                ></flat-pickr>
                            </xc-form-item>
                        </div>
                        <div class="xc-form-inline">
                            <xc-form-item
                                label="结束时间"
                                required
                                :error="errors.first('putinEndTime', 'value')"
                                class="xc-form-item-fixed"
                            >
                                <flat-pickr
                                    v-model="putinEndTime"
                                    class="xc-input"
                                    :config="config"
                                    placeholder="请选择时间"
                                    name="putinEndTime"
                                    v-validate="'required'"
                                    data-vv-as="增播结束时间"
                                ></flat-pickr>
                            </xc-form-item>
                            <xc-form-item
                                label="投放级别"
                                required
                                :error="errors.first('putinLevel', 'value')"
                            >
                                <select
                                    class="xc-select"
                                    name="putinLevel"
                                    v-validate="'required'"
                                    data-vv-as="投放级别"
                                    v-model="putinLevel"
                                >
                                    <option value>请选择</option>
                                    <option
                                        :value="item.value"
                                        v-for="(item, index) in programLevel"
                                        :key="index"
                                        >{{ item.desc }}</option
                                    >
                                </select>
                            </xc-form-item>
                            <xc-form-item
                                label="品牌名称"
                                required
                                :error="errors.first('brandId')"
                            >
                                <select
                                    name="brandId"
                                    class="xc-select"
                                    data-vv-as="品牌名称"
                                    v-validate="'required'"
                                    v-model="brandId"
                                >
                                    <option value="">请选择</option>
                                    <option
                                        :value="item.brandId"
                                        :key="index"
                                        v-for="(item, index) in brandList"
                                    >
                                        {{ item.brandName }}
                                    </option>
                                </select>
                            </xc-form-item>
                        </div>

                        <xc-form-item
                            label="投放周期"
                            required
                            :error="errors.first('putinLimit', 'value')"
                        >
                            <div class="day-list">
                                <div
                                    class="list"
                                    v-for="(item, index) in dayGroup"
                                    :key="index"
                                >
                                    <div
                                        class="day-check-box"
                                        :class="
                                            dayGroup[index].status == true
                                                ? 'dynamicCheckBox'
                                                : 'sDynamicCheckBox'
                                        "
                                        @click="
                                            dayGroup[index].status = !dayGroup[
                                                index
                                            ].status
                                        "
                                    >
                                        <img src="../assets/gou.png" />
                                    </div>
                                    <div class="day-content" v-if="index == 0">
                                        周一
                                    </div>
                                    <div class="day-content" v-if="index == 1">
                                        周二
                                    </div>
                                    <div class="day-content" v-if="index == 2">
                                        周三
                                    </div>
                                    <div class="day-content" v-if="index == 3">
                                        周四
                                    </div>
                                    <div class="day-content" v-if="index == 4">
                                        周五
                                    </div>
                                    <div class="day-content" v-if="index == 5">
                                        周六
                                    </div>
                                    <div class="day-content" v-if="index == 6">
                                        周日
                                    </div>
                                </div>
                            </div>
                            <p class="hint">
                                默认周一到周日（可自定义选择投放周期）
                            </p>
                        </xc-form-item>
                    </form>
                    <div class="xc-device-group-head">
                        <span>请选择增播素材</span
                        ><span v-if="Object.keys(this.checkedList).length"
                            >（共选择{{ webSum }}个广告素材，{{
                                imageSum
                            }}个图片素材，{{ videoSum }}个视频素材）</span
                        >
                    </div>
                    <div
                        class="xc-form-inline"
                        v-if="isImage && Object.keys(this.checkedList).length"
                    >
                        <xc-form-item
                            label="单个图片播放时长(秒)"
                            required
                            :error="errors.first('picPlayTime', 'value')"
                        >
                            <input
                                v-validate="'required|min_value:1'"
                                data-vv-as="播放时长"
                                name="picPlayTime"
                                v-model="picPlayTime"
                                type="text"
                                maxlength="255"
                                class="xc-input"
                                placeholder="请输入"
                            />
                        </xc-form-item>
                    </div>
                    <div
                        class="xc-form-inline"
                        v-if="isWeb && Object.keys(this.checkedList).length"
                    >
                        <xc-form-item
                            label="单个网页播放时长(秒)"
                            required
                            :error="errors.first('viocePlayTime', 'value')"
                        >
                            <input
                                v-validate="'required|min_value:1'"
                                data-vv-as="播放时长"
                                name="viocePlayTime"
                                v-model="viocePlayTime"
                                type="text"
                                maxlength="255"
                                class="xc-input"
                                placeholder="请输入"
                            />
                        </xc-form-item>
                    </div>
                    <div class="xc-device-group">
                        <div class="xc-device-group-title">分组:</div>
                        <div
                            :class="
                                closeGroups
                                    ? 'xc-device-group-main-close'
                                    : 'xc-device-group-main'
                            "
                        >
                            <div
                                :class="
                                    item.checked
                                        ? 'xc-device-group-item-checked'
                                        : 'xc-device-group-item'
                                "
                                v-for="(item, index) in groupValue"
                                :key="index"
                                :data-index="index"
                                :data-id="item.fileGroupId"
                                @click="selectGroup"
                            >
                                {{ item.fileGroupName }} ({{ item.filetotal }})
                            </div>
                            <div
                                class="xc-device-group-close"
                                @click="closeGroup"
                                v-if="!closeGroups"
                            >
                                <span>收起</span>
                                <img
                                    src="../assets/gy/arrow-up.png"
                                    alt="收起"
                                />
                            </div>
                            <div
                                class="xc-device-group-open"
                                @click="openGroup"
                                v-if="closeGroups"
                            >
                                <span>展开</span>
                                <img
                                    src="../assets/gy/arrow-up.png"
                                    alt="展开"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="xc-form-inline">
                        <div class="xc-device-row-item">
                            <span class="xc-device-row-title">素材类型:</span>
                            <xc-radio
                                :radio-value="materialType"
                                @radio-fun="radioSelectFun"
                            />
                        </div>
                    </div>

                    <div class="xc-form-inline">
                        <div class="xc-device-row-item">
                            <span class="xc-device-row-title">素材名称:</span>
                            <input
                                type="text"
                                maxlength="255"
                                class="xc-device-input"
                                placeholder="请输入素材名称"
                                v-model="mix_query.fileName"
                            />
                        </div>
                        <button
                            type="submit"
                            class="xc-btn xc-btn-primary"
                            @click.prevent="mix_search"
                        >
                            查询
                        </button>
                    </div>
                    <div class="xc-device-material">
                        <div
                            class="xc-device-material-item"
                            v-for="(item, index) in list"
                            :key="index"
                        >
                            <img
                                :src="item.fileImageUrl"
                                alt="素材图"
                                :data-filename="item.fileName"
                                :data-filetype="item.fileType"
                                :data-url="item.url"
                                @click="viewMaterial"
                            />
                            <div class="xc-device-material-name">
                                {{ item.fileName }}
                            </div>
                            <div
                                :class="
                                    checkedList[item.fileId]
                                        ? 'xc-material-checked-box-choose'
                                        : 'xc-material-checked-box'
                                "
                                @click.stop="selectMaterial(item, index)"
                            ></div>
                        </div>
                    </div>
                </div>
                <div class="xc-modal-footer xc-flex-item">
                    <div class="xc-btn-group">
                        <div class="xc-btn xc-btn-default" @click="layerClose">
                            关闭
                        </div>
                        <div
                            class="xc-btn xc-btn-primary"
                            @click="sureCreasedPlay"
                        >
                            确定增播
                        </div>
                    </div>

                    <!-- 分页 -->
                    <xc-pagination
                        @change="mix_pageChange"
                        :page="mix_page"
                        :total="mix_total"
                        :size="mix_pageSize"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import myLayerImport from "@/libs/myLayer";

import mixin from "../xc-ui/mixins/list";
import deviceApi from "../api/device";

// vee-validate验证
import "@/libs/vee-validate";
import "@/utils/form-format";

// 日期控件
import "@/libs/flatpickr";
import { constants } from "crypto";
import { setTimeout } from "timers";

import nullToStr from "../utils/null-tostring";

export default {
    name: "materialPreview",
    data() {
        return {
            dayGroup: [
                {
                    index: 0,
                    status: true,
                    text: "周一"
                },
                {
                    index: 1,
                    status: true,
                    text: "周二"
                },
                {
                    index: 2,
                    status: true,
                    text: "周三"
                },
                {
                    index: 3,
                    status: true,
                    text: "周四"
                },
                {
                    index: 4,
                    status: true,
                    text: "周五"
                },
                {
                    index: 5,
                    status: true,
                    text: "周六"
                },
                {
                    index: 6,
                    status: true,
                    text: "周日"
                }
            ],

            checkedList: {},

            webSum: 0,

            imageSum: 0,

            videoSum: 0,
            // 列表key
            mix_listKey: "list",

            // 列表唯一字段
            mix_listId: "programVersion",

            // 节目名称
            programName: "增播",

            // 图片播放时长
            picPlayTime: 15,

            // 视频播放长度
            viocePlayTime: 10,

            // 投放限制
            putinLimit: "",

            // 投放级别
            putinLevel: "",
            brandList: [],
            brandId: "", //品牌id
            deviceCode: "",
            deviceType: "",
            deviceResolution: "",

            // 日期选择
            putinStartTime: "",
            putinEndTime: "",
            // https://flatpickr.js.org/options/
            config: {
                // 时间格式
                // dateFormat: "H:i:S",
                // 否启用时间选择
                enableTime: true,
                // 选择器中是否可以选择秒
                enableSeconds: true,
                // 是否显示日期
                noCalendar: false,
                time_24hr: true
            },

            channel: 1,

            list: [],
            // 默认查询参数
            mix_query: {
                fileName: "",
                fileType: "image"
            },

            programLevel: [],
            programLimit: [],

            // 获取参数
            program: this.$route.query,

            // 素材类型
            materialType: [
                {
                    text: "图片",
                    value: "web",
                    id: 1,
                    active: true
                },
                {
                    text: "视频"
                },
                {
                    text: "网页"
                }
            ],

            // 增播素材
            materialValue: [
                {
                    addTime: 1557901458686,
                    createPerson: 1,
                    createPersonType: 1,
                    departmentId: null,
                    duration: null,
                    fileId: 5,
                    fileImageUrl:
                        "https://obs-ck.obs.cn-east-2.myhwclouds.com/file/picture/效果图1_compress.jpg",
                    fileName: "效果图1",
                    fileSuffix: "jpg",
                    fileType: "image",
                    groupId: 2,
                    md5: "bfc6ab1af311f66495a14acac67ab898",
                    size: 977086,
                    url:
                        "https://obs-ck.obs.cn-east-2.myhwclouds.com/file/picture/效果图1_compress.jpg"
                }
            ],

            // 分组
            groupValue: [],

            closeGroups: true,
            showOpenGroup: true
        };
    },

    computed: {
        isWeb() {
            let isWeb;

            if (this.checkedList && Object.keys(this.checkedList).length) {
                // this.checkedList.map((v=>{
                //   if(v.fileType == 'image') {
                //     isImage = true
                //   }
                // }))

                for (let i in this.checkedList) {
                    if (this.checkedList[i].fileType == "web") {
                        isWeb = true;
                    }
                }
            }
            return isWeb;
        },

        isImage() {
            let isImage;

            if (this.checkedList && Object.keys(this.checkedList).length) {
                for (let i in this.checkedList) {
                    if (this.checkedList[i].fileType == "image") {
                        isImage = true;
                    }
                }
            }
            return isImage;
        },

        isVideo() {
            let isVideo;

            if (this.checkedList && Object.keys(this.checkedList).length) {
                for (let i in this.checkedList) {
                    if (this.checkedList[i].fileType == "video") {
                        isVideo = true;
                    }
                }
            }
            return isVideo;
        }
    },

    watch: {
        checkedList(newValue) {
            this.webSum = 0;
            this.imageSum = 0;
            this.videoSum = 0;
            for (let i in newValue) {
                if (newValue[i].fileType == "web") {
                    this.webSum++;
                } else if (newValue[i].fileType == "image") {
                    this.imageSum++;
                } else if (newValue[i].fileType == "video") {
                    this.videoSum++;
                }
            }
        }
    },

    async created() {
        // 加载JS
        await myLayerImport();

        this.getNowFormatDate();
        let { deviceType, deviceResolution, deviceCode } = nullToStr(
            this.$route.query
        );
        this.deviceType = deviceType;
        this.deviceResolution = deviceResolution;
        this.deviceCode = deviceCode;
    },

    mounted() {
        let that = this;

        // 获取全局配置
        deviceApi.getGlobalconfig().then(v => {
            this.programLevel = v.data.programLevel;
            this.programLimit = v.data.programLimit;
            this.putinLimit = v.data.programLimit[0].value;
        });

        // 获取素材类型
        deviceApi.getAllFileType().then(v => {
            let arr = [];
            for (let i = 0; i < v.data.length; i++) {
                let obj = {};
                obj.text = v.data[i].typeName;
                obj.value = v.data[i].typeEn;
                obj.id = v.data[i].fileTypeId;
                if (v.data[i].typeEn == "image") {
                    obj.active = true;
                }

                arr.push(obj);
            }

            this.materialType = arr;
        });

        this.getAllBrands();
        this.getFileGroup();
    },

    methods: {
        //获取品牌
        getAllBrands() {
            this.$http.get("/brand/listAllBrands").then(res => {
                this.brandList = res.data;
            });
        },
        // 预览素材
        viewMaterial(e) {
            let data = e.target.dataset;

            var program = {
                name: data.filename,
                type: data.filetype,
                url: data.url
            };
            myLayer.open({
                type: 2,
                title: false,
                shadeClose: true,
                closeBtn: 0, //不显示关闭按钮
                area: ["981px", "550px"],
                content:
                    "/admin/material/preview?name=" +
                    program.name +
                    "&type=" +
                    program.type +
                    "&url=" +
                    program.url,
                success: function(layero, index) {}
            });
        },

        layerClose() {
            var index = parent.layer.getFrameIndex(window.name);
            parent.layer.close(index);
        },

        getFileGroup() {
            // 获取素材分组
            deviceApi.getFileGroup().then(v => {
                v.data[0].checked = true;
                this.groupValue = v.data;
            });
        },

        // 初始化数据
        initData(v) {
            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query
            };

            deviceApi.getFileByPage(search).then(ret => {
                this.list = this.mix_format(ret.data.list);
                this.mix_total = ret.data.total;
                this.mix_page = ret.data.pageNum;
                this.mix_pageSize = ret.data.pageSize;
            });
        },

        // 确定增播
        sureCreasedPlay() {
            // 验证器命名空间
            const scope = "form-list";

            // vee表单验证方法
            this.$validator
                .validateAll(scope)
                .then(validate => {
                    if (validate) {
                        return this.$formFormat(document.filesplay);
                    } else {
                        let error = this.errors.items[0].msg;
                        this.$message.error(error);
                    }
                })
                .then(formData => {
                    let that = this;
                    // 表单选择值
                    if (
                        (this.isWeb && this.isImage) ||
                        (this.isWeb && this.isVideo)
                    ) {
                        this.$message.error(
                            "视频+图片可以混用，网页只能单独使用"
                        );
                        return;
                    }

                    let sourceJson = {};
                    let sourceArr = [];

                    for (let i in this.checkedList) {
                        if (this.checkedList[i].fileType == "image") {
                            this.checkedList[i].duration =
                                this.picPlayTime * 1000;
                        }
                        if (this.checkedList[i].fileType == "web") {
                            this.checkedList[i].duration =
                                this.viocePlayTime * 1000;
                        }
                        sourceArr.push(this.checkedList[i]);
                    }
                    console.log(sourceArr);
                    sourceJson[this.deviceResolution] = sourceArr;

                    formData.sourceJson = JSON.stringify(sourceJson);
                    formData.deviceCode = this.deviceCode;

                    formData.putinLimit = [];
                    for (let item of this.dayGroup) {
                        if (item.status) {
                            formData.putinLimit = [
                                ...formData.putinLimit,
                                item.index
                            ];
                        }
                    }
                    console.log(formData);

                    deviceApi.getProgramAdded(formData).then(v => {
                        // 成功后关闭窗口
                        that.$message.success("增播成功");
                        setTimeout(function() {
                            that.layerClose();
                        }, 2000);
                    });
                });
        },

        // 单选按钮回调
        radioSelectFun: function(value) {
            this.mix_query.fileType = value;

            // 获取分组（待修改）
            this.getFileGroup();

            // 筛选请求
            this.initData();
        },

        // 收起组名
        closeGroup() {
            this.closeGroups = true;
        },

        // 展开组名
        openGroup() {
            this.closeGroups = false;
        },

        // 选择组名
        selectGroup(e) {
            let { index, id } = e.currentTarget.dataset;
            this.mix_query.fileGroupId = id;
            const groupValue = [...this.groupValue];

            for (let item of groupValue) {
                item.checked = false;
            }
            groupValue[index].checked = true;
            this.groupValue = groupValue;

            this.initData();
        },

        // 增播选择素材
        selectMaterial(item, index) {
            // const checkedList = {
            //   ...this.checkedList
            // }
            // if(checkedList[item.fileId]){
            //   delete checkedList[item.fileId];
            // } else {
            //   checkedList[item.fileId] = item
            // }
            // this.checkedList = checkedList;

            if (this.checkedList[item.fileId]) {
                this.$delete(this.checkedList, item.fileId);
            } else {
                this.$set(this.checkedList, item.fileId, item);
            }
        },

        // 获取当前日期
        getNowFormatDate() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            this.programName += currentdate;
        }
    },
    mixins: [mixin]
};
</script>

<style lang="scss" scoped>
.xc-modal-footer {
    display: flex;
    align-items: center;
}
.material {
    width: 100%;
    height: 100%;
    .myMaterial {
        width: 100%;
        height: 100%;
        border: 0;
    }
}
.xc-device-group-head {
    font-size: 14px;
    color: #6e7a90;
    margin-bottom: 16px;
}

.xc-device-group-head span:first-child {
    font-size: 18px;
}

.xc-device-group {
    display: flex;
}

.xc-device-group-title {
    width: 40px;
    line-height: 24px;
}

.xc-device-group-main {
    flex: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    overflow: hidden;
}

.xc-device-group-main-close {
    flex: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    overflow: hidden;
    height: 38px;
    position: relative;
    padding-right: 84px;
    box-sizing: border-box;
}

.xc-device-group-close,
.xc-device-group-open {
    display: flex;
    align-items: center;
    color: #507dde;
    margin-bottom: 14px;
    cursor: pointer;
}

.xc-device-group-close span,
.xc-device-group-open span {
    margin-right: 2px;
}

.xc-device-group-close span {
    margin-left: 5px;
}

.xc-device-group-close img,
.xc-device-group-open img {
    width: 9px;
    height: 6px;
}

.xc-device-group-open img {
    transform: rotate(180deg);
}

.xc-device-group-open {
    position: absolute;
    top: 0;
    right: 40px;
}

.xc-device-group-item {
    padding: 5px 12px;
    line-height: 14px;
    font-size: 14px;
    color: #6e7a90;
    margin-bottom: 14px;
    cursor: pointer;
}

.xc-device-group-item:hover {
    color: rgba(80, 125, 222, 0.5);
}

.xc-device-group-item-checked {
    padding: 5px 12px;
    line-height: 14px;
    font-size: 14px;
    color: #fff;
    background: rgba(80, 125, 222, 0.5);
    border-radius: 8px;
    margin-bottom: 14px;
    cursor: pointer;
}

.xc-device-material {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.xc-device-material-item,
.xc-device-material-item-checked,
.xc-device-material-program,
.xc-device-material-program-checked {
    width: 222px;
    height: 127px;
    border-radius: 4px;
    background: #eee;
    margin-right: 16px;
    margin-bottom: 16px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    box-sizing: border-box;
}

.xc-device-material-program,
.xc-device-material-program-checked {
    margin-right: 0;
}

.xc-device-material-name {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 21px;
    background-color: rgba(0, 0, 0, 0.65);
    line-height: 20px;
    padding: 0 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: white;
    font-size: 12px;
}

.xc-device-material-item img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.xc-device-material-item-checked img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.xc-device-material-item:nth-child(4n),
.xc-device-material-item-checked:nth-child(4n) {
    margin-right: 0;
}

.xc-device-row-item {
    display: flex;
    align-items: center;
}

.xc-device-row-title {
    margin-right: 8px;
}

.xc-device-input {
    flex: 1;
    width: 220px;
    height: 32px;
    line-height: 32px;
    padding: 0 10px;
    background-color: #ffffff;
    border-radius: 6px;
    border: solid 1px #cfd5e0;
    color: #808b9e;
    font-size: inherit;
    margin-right: 14px;
}

::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #cfd5e0;
}
:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #cfd5e0;
}
::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #cfd5e0;
}
:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #cfd5e0;
}

.xc-device-tipText {
    font-size: 18px;
    color: #6e7a90;
}

.xc-material-checked-box {
    width: 16px;
    height: 16px;
    background-color: #ffffff;
    border-radius: 4px;
    border: solid 1px #cfd5e0;
    position: absolute;
    top: 9px;
    right: 9px;
}

.xc-material-checked-box-choose {
    width: 16px;
    height: 16px;
    background-color: #507dde;
    border-radius: 4px;
    border: solid 1px #cfd5e0;
    position: absolute;
    top: 9px;
    right: 9px;
}

.xc-material-checked-box-choose::after {
    content: "";
    width: 6px;
    height: 10px;
    border-color: #fff;
    border-style: solid;
    border-width: 0 2px 2px 0;
    border-radius: 2px;
    transform: rotate(45deg);
    position: absolute;
    top: 0px;
    right: 4px;
    z-index: 11;
}

.xc-form-item-label {
    width: 84px;
}

.day-list {
    display: flex;
    height: 30px;
    line-height: 30px;
    .list {
        display: flex;
        .day-check-box {
            width: 16px;
            height: 16px;
            border: 1px solid #d7d7d7;
            border-radius: 4px;
            margin: 7px 10px 7px 0px;
        }
        .dynamicCheckBox {
            border: 1px solid #4a80f7;
            background-color: #4a80f7;
            img {
                display: block;
                width: 14px;
                height: 14px;
                border-radius: 4px;
                cursor: pointer;
            }
        }
        .sDynamicCheckBox img {
            display: block;
        }
        .day-content {
            margin-right: 20px;
        }
    }
}
.hint {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    color: red;
}
</style>
